module.exports = __webpack_public_path__ + "static/media/maps-figma.c94e8428.png";